import { Button } from "./ui/button";

const IconButton = ({variant, size, rounded, Icon, onClick, className, ...props}) => {
  return (
    <Button
      variant={variant}
      size={size}
      rounded={rounded || 'full' }
      disabled={props.disabled || false}
      onClick={onClick}
      className={className}
    >
      <Icon className="w-4 h-4 font-extrabold" />
    </Button>
  );
};

export default IconButton;
